import { render, staticRenderFns } from "./crearSubcategoriaModal.vue?vue&type=template&id=b7cd4604"
import script from "./crearSubcategoriaModal.vue?vue&type=script&lang=js"
export * from "./crearSubcategoriaModal.vue?vue&type=script&lang=js"
import style0 from "./crearSubcategoriaModal.vue?vue&type=style&index=0&id=b7cd4604&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports